import { render, staticRenderFns } from "./CourseOwnList.vue?vue&type=template&id=2ffd64dc"
import script from "./CourseOwnList.vue?vue&type=script&lang=js"
export * from "./CourseOwnList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports